module.exports = __webpack_public_path__ + "static/images/077edb9c37766f5982c8d8d45f5e12c1.svg";